/** API route map: URLS.Controller.Garnishment */
export const Garnishment = {
      Name: 'Garnishment/',
      AddGarnishment: 'add-garnishment',
      GetAllGarnishment: 'get-all-garnishment',
      UpdateGarnishment: 'update-garnishment',
      DeleteGarnishment: 'delete-garnishment',
      Patch: 'star-rating',
      GetPayee: 'get-all-payee',
      GetAllGarnishmentCheck: 'get-all-garnishment-check',
};
